import { CanvasTexture, Group, Mesh, MeshBasicMaterial, Sprite, SpriteMaterial, TorusGeometry, Vector3 } from "three"
import { createOffscreenCanvas } from "../../canvas/create_canvas"
import { getCanvas2dContext } from "../../canvas/get_canvas_2d_context"
import dijkstraDirectionCharsUpperCase from "../../core/direction/dijkstraDirectionCharsUpperCase"
import { dijkstraDirections } from "../../core/direction/dijkstraDirections"
import setLayerRecursively from "../fn/setLayerRecursively"

export default function createOnScreenCompassObject3D() {
  const compass = new Group() // Compass container
  compass.name = 'CompassGroup'

  // Create a ring
  const ringGeometry = new TorusGeometry(1.2, 0.05, 16, 100)
  const ringMaterial = new MeshBasicMaterial({ color: 0xffffff })
  const ring = new Mesh(ringGeometry, ringMaterial)
  compass.add(ring)

  const ps = 1.5
  const positions = [
    dijkstraDirections[2],
    dijkstraDirections[1],
    dijkstraDirections[0],
    dijkstraDirections[3],
  ].map(dir => {
    return new Vector3(dir.dx * ps, dir.dy * ps, 0)
  })

  dijkstraDirectionCharsUpperCase.forEach((dir, i) => {
    // Create a canvas element
    const size = 128
    const canvas = createOffscreenCanvas(size, size)
    const ctx = getCanvas2dContext(canvas)
    if (ctx) {
      // Draw the text
      ctx.font = '64px Arial'
      ctx.fillStyle = '#ff0000'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(dir, canvas.width / 2, canvas.height / 2)
    }

    // Create a texture from the canvas
    const texture = new CanvasTexture(canvas)

    // Create a sprite material with the texture
    const spriteMaterial = new SpriteMaterial({ map: texture })

    // Create a sprite and set its position
    const sprite = new Sprite(spriteMaterial)
    sprite.position.copy(positions[i])
    sprite.scale.set(0.5, 0.5, 1) // Adjust scale as needed

    // Add the sprite to the compass
    compass.add(sprite)
  })

  // compass.visible = false

  // createMountedInterval(() => {
  //   camera.layers.set(1)
  // }, 1000)

  setLayerRecursively(compass, 1)

  return compass
}